export const handleUpdateProfileError = (error: any) => {
  console.error('Error updating profile:', error.message);
  throw new Error(error.message || 'Failed to update profile.');
};
